<div class="form-container service-form">
  <div #notification *ngIf="formStatus === FormStatus.COMPLETE || formStatus === FormStatus.ERROR">
    <fcom-notification
      aria-live="polite"
      class="pr-small-y pr-clear-t mr-clear block"
      [theme]="formStatus === FormStatus.ERROR ? NotificationTheme.ALERT : NotificationTheme.INFO"
      [iconName]="formStatus === FormStatus.ERROR ? SvgLibraryIcon.INFO : SvgLibraryIcon.CHECKMARK"
    >
      {{
        (formStatus === FormStatus.ERROR ? 'SERVICE_FORMS.serviceForms.error.title' : 'plus.profile.updateSuccess')
          | finLocalization
      }}
    </fcom-notification>
  </div>
  <span class="block pr-medium-b font-body-1 nordic-blue-900-text">{{
    'SERVICE_FORMS.serviceForms.mandatoryFields' | finLocalization
  }}</span>
  <!-- While sending -->
  <div *ngIf="formStatus === FormStatus.LOADING" class="relative loader">
    <fcom-loader [loaderType]="LoaderTheme.INLINE"></fcom-loader>
  </div>
  <form [formGroup]="reactiveForm" (ngSubmit)="onSubmit()" [finFormErrorFocus]="reactiveForm">
    <ng-container
      *ngIf="formStatus === FormStatus.INITIAL || formStatus === FormStatus.COMPLETE || formStatus === FormStatus.ERROR"
    >
      <div class="flex flex--row flex--wrap form-subgroup">
        <fin-form-input-text
          [parentForm]="reactiveForm"
          [controlName]="GuardianInformationFormField.GUARDIAN_NAME"
          [translationPrefix]="'SERVICE_FORMS.serviceForms.fields.guardianName'"
        ></fin-form-input-text>
        <fin-form-input-text
          [parentForm]="reactiveForm"
          [controlName]="GuardianInformationFormField.GUARDIAN_PHONE_NUMBER"
          [translationPrefix]="'SERVICE_FORMS.serviceForms.fields.guardianPhoneNumber'"
        ></fin-form-input-text>
        <fin-form-input-text
          [parentForm]="reactiveForm"
          [controlName]="GuardianInformationFormField.GUARDIAN_EMAIL"
          [translationPrefix]="'SERVICE_FORMS.serviceForms.fields.guardianEmail'"
        ></fin-form-input-text>
        <fin-form-input-text
          [parentForm]="reactiveForm"
          [controlName]="GuardianInformationFormField.GUARDIAN_MEMBER_NUMBER"
          [translationPrefix]="'SERVICE_FORMS.serviceForms.fields.guardianMemberNumber'"
        ></fin-form-input-text>
      </div>
      <div
        class="flex flex--row flex--wrap form-subgroup mr-small-b"
        *ngIf="hostingComponent === GuardianInformationHostingComponent.LOST_CARD"
      >
        <fin-form-input-checkbox
          [parentForm]="reactiveForm"
          [controlName]="GuardianInformationFormField.GUARDIAN_CONSENT"
          [translationPrefix]="'SERVICE_FORMS.serviceForms.fields.guardianConsent'"
        >
        </fin-form-input-checkbox>
      </div>
    </ng-container>
    <div
      class="ps-small-t mr-xxsmall-r"
      [ngClass]="{
        'align-left': hostingComponent === GuardianInformationHostingComponent.LOST_CARD,
        'align-right': hostingComponent === GuardianInformationHostingComponent.UPDATE_PROFILE,
      }"
    >
      <fcom-button [type]="ButtonType.SUBMIT" [text]="submitButtonText | finLocalization"></fcom-button>
    </div>
  </form>
</div>
